import React from 'react';
import './TabSelector.scss'

function TabSelector(props) {
    const {
        options,
        setValue,
        value,
        tabContainerClassName,
    } = props;
    
    const _setValue = (key) => {
        setValue(key);
    }

    const parsedOptions = () => {
        return options.map(option => {
            return (
            <div 
                onClick={() => _setValue(option.key)} 
                key={option.key} 
                className={`${(value === option.key ? "tabSelectorOptionSelected" : "tabSelectorOptionAvailable")} ` }>
                {option.label}
            </div>
            )
        })
    }

    return (
        <div className={`tabSelectorContainer ${(tabContainerClassName ? tabContainerClassName : '')}`}>
            {parsedOptions()}    
        </div>
    )
}

export default TabSelector;
